import React from 'react';
import { ArrowUpRight, ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';
type Project = {
  name: string;
  trade: string;
  location: string;
  url: string;
  image: string;
};
// 👉 Reemplaza estos con los websites reales que has construido.
// Solo cambia "image" por la URL de la captura/mockup y "url" por el enlace del sitio.
const projects: Project[] = [{
  name: 'Jezaway',
  trade: 'Junk Removal',
  location: 'jezaway.com',
  url: 'https://jezaway.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://jezaway.com'
}, {
  name: 'Blue Sky Contractor',
  trade: 'Construcción',
  location: 'blueskycontractor.com',
  url: 'https://blueskycontractor.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://blueskycontractor.com'
}, {
  name: 'Yeimateo Lawn Care',
  trade: 'Landscaping',
  location: 'yeimateolawncare.com',
  url: 'https://yeimateolawncare.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://yeimateolawncare.com'
}, {
  name: 'Jose Junk Removal Service',
  trade: 'Junk Removal',
  location: 'josejunkremovalservice.com',
  url: 'https://josejunkremovalservice.com/',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://josejunkremovalservice.com/'
}, {
  name: 'South Coast Arbor Care',
  trade: 'Tree Service',
  location: 'southcoastarborcare.com',
  url: 'https://southcoastarborcare.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://southcoastarborcare.com'
}, {
  name: 'I and A Landscaping',
  trade: 'Landscaping',
  location: 'iandalandscaping.com',
  url: 'https://iandalandscaping.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://iandalandscaping.com'
}, {
  name: 'North Face Irrigation',
  trade: 'Irrigación',
  location: 'northfaceirrigation.com',
  url: 'https://northfaceirrigation.com',
  image: 'https://image.thum.io/get/width/1200/crop/750/https://northfaceirrigation.com'
}];
export function PortfolioSection() {
  return <section id="portafolio" className="py-24 bg-dark relative overflow-hidden" data-id="element-252" data-mp="2k4dkfca4l4mk">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-253" data-mp="2p1vux73sjrwo"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-254" data-mp="2tvi1qin9x1kk">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-255" data-mp="2ysgt4tfjyuf2">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gold/10 border border-gold/20 mb-6" data-id="element-256" data-mp="3crznmjffy78w">
            <span className="text-gold text-sm font-bold tracking-wide uppercase" data-id="element-257" data-mp="1dhi4xgjq5s1j">
              Nuestro Trabajo
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-258" data-mp="1av8z9rklik0f">
            Websites Que <span className="text-gold" data-id="element-259" data-mp="163qz35qecngi">Hemos Construido</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-260" data-mp="1155wx0rl3tpf">
            Diseños premium que convierten visitantes en clientes — listos en
            menos de 72 horas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-261" data-mp="1ttladiv2i3yn">
          {projects.map((project, index) => <motion.a key={index} href={project.url} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="group relative rounded-3xl overflow-hidden border border-white/10 bg-dark-100 hover:border-gold/40 transition-all duration-300" data-id="element-262" data-mp="1ov08zg42xe8m" data-mpi={index}>
              {/* Mockup image */}
              <div className="relative aspect-[16/10] overflow-hidden" data-id="element-263" data-mp="1ieglvphnymbg">
                <img src={project.image} alt={`Website de ${project.name}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-264" data-mp="1nc8njb841msu" />
                <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/30 to-transparent" data-id="element-265" data-mp="2fzuoebpyedc0"></div>

                {/* Hover view button */}
                <div className="absolute top-4 right-4 w-11 h-11 rounded-full bg-gold text-dark flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-lg" data-id="element-266" data-mp="262q1uas74fuo">
                  <ArrowUpRight className="w-5 h-5" data-id="element-267" data-mp="uoci9i4h6mkg" />
                </div>
              </div>

              {/* Info */}
              <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-268" data-mp="n3aeb7ymru3r">
                <span className="inline-block text-xs font-bold uppercase tracking-wider text-gold bg-gold/10 border border-gold/20 px-3 py-1 rounded-full mb-3" data-id="element-269" data-mp="i5h669droq0u">
                  {project.trade}
                </span>
                <h3 className="text-2xl font-bold text-white mb-1 flex items-center gap-2" data-id="element-270" data-mp="s354taehuhoa">
                  {project.name}
                  <ExternalLink className="w-4 h-4 text-gray-400 group-hover:text-gold transition-colors" data-id="element-271" data-mp="4ec30xb6xflr" />
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-272" data-mp="3viaim6b8hnva">{project.location}</p>
              </div>
            </motion.a>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mt-16" data-id="element-273" data-mp="9cnc35tnvm2x">
          <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold rounded-full text-dark bg-gold hover:bg-gold-400 transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(212,175,55,0.3)]" data-id="element-274" data-mp="3crjcreqggfln">
            Quiero El Mío →
          </a>
        </motion.div>
      </div>
    </section>;
}